<template>
    <ul
        class="healthcheck-battery-status"
        data-test-id="healthcheck-battery-status"
    >
        <li data-test-id="battery-status-icon">
            <img
                :src="`/images/relays/${icon}.svg`"
                :alt="icon"
            />
        </li>
        <li data-test-id="battery-status-label">
            <span
                v-if="!hasIntegratedPower"
                data-test-id="level"
                >{{ batteryLevelDisplay }}</span
            >
            <span
                v-if="row.is_charging"
                data-test-id="charging"
                >Charging</span
            >
            <span
                v-if="row.usb_connected"
                data-test-id="connected"
                >Connected</span
            >
        </li>
    </ul>
</template>

<script>
import canToast from '@/mixins/canToast'
import needsOrganizationSlug from '@/mixins/needsOrganizationSlug'
import { findBatteryRange } from '../radio-status-definitions'

export default {
    mixins: [canToast, needsOrganizationSlug],
    props: ['row'],

    computed: {
        hasIntegratedPower() {
            return this.row.serial_number?.startsWith('MNE')
        },
        icon() {
            if (this.hasIntegratedPower) {
                return 'battery-connection-connected'
            }

            const range = findBatteryRange(this.row.battery_level)
            const rangeIcon = range ? range.icon : 'battery-unknown'

            return `${rangeIcon}${this.row.is_charging ? '-charging' : ''}`
        },
        batteryLevelDisplay() {
            if (Number.isNaN(parseInt(this.row.battery_level))) {
                return 'Unknown'
            }

            return `${this.row.battery_level}%`
        },
    },
}
</script>

<style scoped lang="scss">
ul.healthcheck-battery-status {
    display: flex;
    flex-direction: row;
    align-items: center;

    li {
        margin-bottom: 0 !important;

        span {
            display: block;
            padding-left: 12px;
        }
    }
}
</style>
